module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/info-80ac9c1cc9bfb6039899264f7aefb04a.png";